// Write your JS code here
import {Component} from 'react'
import BlogItem from '../BlogItem'
import './index.css'

class BlogList extends Component {
  render() {
    const {blogsList} = this.props
    console.log(blogsList)
    return (
      <div className="home-container">
        <div className="image-container">
          <img
            src="https://assets.ccbp.in/frontend/react-js/profile-img.png"
            className="profile-image"
            alt="profile"
          />
          <h1>Wade Warren</h1>
          <p>Software Developer at UK</p>
        </div>
        <div>
          <ul>
            {blogsList.map(eachBlog => (
              <BlogItem key={eachBlog.title} eachBlog={eachBlog} />
            ))}
          </ul>
        </div>
      </div>
    )
  }
}

export default BlogList
